<template>
  <div id="app" :class="computedPhone">
    <router-view />
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import Web3 from 'web3';
import {logOut, getScAddress} from './assets/api/public';
import {
  setNFTAddress,
  setChainParams,
  MARKET_ABI,
  MH_NFT_ABI,
  MBB_NFT_ABI,
  MG_TOKEN_ABI,
  GAME_ABI,
  MU_ABI,
  setContracts
} from './assets/js/config';
// import {foxLogin, getFoxNonce} from './assets/api/public';

// const web3 = new Web3(Web3.givenProvider || `${location.protocol}}//${location.host}`);
const web3 = new Web3(Web3.givenProvider || 'http://192.168.1.99:9329');
// let web3 = Web3 || undefined;
// ContractABI
// const contractAddress = '0xe8d06113a84f53825cdc293e974245a519a0e87b';
//
// const MyContract = new web3.eth.Contract(ABI, contractAddress);
const gasLimit = 3000000;
const gasPrice = web3.eth.gasPrice;
let options = {
  'gasPrice': gasPrice,
  'gas': gasLimit
}

export default {
  mounted() {
    window.onresize = () => {
      this.setWidth(document.documentElement.clientWidth);
    };
    window.ethereum.on('accountsChanged', async (nAccounts) => {
      let d = localStorage.getItem('token')
      if (d) {
        this.$notify.error({
          title: 'Failed',
          message: 'Account changed, please log in again'
        });
        logOut(this)
      }
      console.log(nAccounts)
    });
    // listen to chainChanged
    window.ethereum.on('chainChanged', async (nAccounts) => {
      let d = localStorage.getItem('token')
      if (d) {
        this.$notify.error({
          title: 'Failed',
          message: 'Account changed, please log in again'
        });
        logOut(this);
      }
      console.log(nAccounts)
    });
    getScAddress().then(data => {
      let nftAddress = {};
      let chainParams = {};
      let nativeCurrency = {};
      let contracts = {};
      for(let i = 0; i < data.length; i++){
        let item = data[i];
        if(item.name === 'mbb1155'){
          nftAddress.mbbNFTAddress = item.address;
        }else if(item.name === 'mh721'){
          nftAddress.mhNFTAddress = item.address;
        }else if(item.name === 'market'){
          nftAddress.marketAddress = item.address;
        }else if(item.name === 'mg20'){
          nftAddress.mgTokenAddress = item.address;
        }else if(item.name === 'mu20'){
          nftAddress.muAddress = item.address;
        }else if(item.name === 'game'){
          nftAddress.gameAddress = item.address;
        }else if(item.name === 'chainId'){
          chainParams.chainId = '0x' + Number(item.address).toString(16);
        }else if(item.name === 'rpcUrl'){
          chainParams.rpcUrl = [item.address];
        }else if(item.name === 'chainName'){
          chainParams.chainName = item.address;
        }else if(item.name === 'browser'){
          chainParams.blockExplorerUrls = item.address ? [item.address] : [];
        }else if(item.name === 'currencyName'){
          nativeCurrency.name = item.address;
        }else if(item.name === 'currencySymbol'){
          nativeCurrency.symbol = item.address;
        }else if(item.name === 'currencyDecimals'){
          nativeCurrency.decimals = item.address;
        }
      }
      if(nftAddress.mhNFTAddress){
        setNFTAddress(nftAddress);
        contracts.mhNftContract = new web3.eth.Contract(MH_NFT_ABI, nftAddress.mhNFTAddress, options);
        contracts.mbbNftContract = new web3.eth.Contract(MBB_NFT_ABI, nftAddress.mbbNFTAddress, options);
        contracts.marketContract = new web3.eth.Contract(MARKET_ABI, nftAddress.marketAddress, options);
        contracts.mgTokenContract = new web3.eth.Contract(MG_TOKEN_ABI, nftAddress.mgTokenAddress, options);
        contracts.gameContract = new web3.eth.Contract(GAME_ABI, nftAddress.gameAddress, options);
        contracts.muContract = new web3.eth.Contract(MU_ABI, nftAddress.muAddress, options);
        setContracts(contracts);
      }
      if(chainParams.chainId && nativeCurrency.name){
        chainParams.nativeCurrency = nativeCurrency;
        setChainParams(chainParams);
      }
      console.log('---getScAddress---', nftAddress, chainParams)
      // setChainParams(chainParams);
    }).catch((err) => {
      console.log('---getScAddress---', err)
    })
  },
  computed: {
    ...mapState(['screenWidth','fromAddress']),
    computedPhone() {
      if (this.screenWidth < 1024) {
        return 'mobile';
      }
      return 'computer';
    }
  },
  methods: {
    ...mapMutations(['setWidth','setFromAddress'])
  }
};
</script>
<style lang="scss"></style>
